import React from 'react';

import { TableCell } from '@material-ui/core';

import { IKImage } from '../../../../../components/IKImage';

const ImageCell = ({ row, k, styles, align }) => {
  return (
    <TableCell key={k} className={styles.contentCell} align={align}>
      <IKImage
        className={styles.imageCellContent}
        path={row[k]}
        srcset={[{ width: 50, height: 30 }]}
        sizes="100vw"
      />
    </TableCell>
  );
};

export default ImageCell;
